export const lineManagerQueryKeys = {
  get_line_manager: (queryParams = {}) => ['line_manager', queryParams]
}
